import _ from 'underscore'
import Backbone from '@polleverywhere/backbone'
import { query, mutation } from '@polleverywhere/graphql-client'

function runQuery (action, args) {
  if (action === 'query') {
    return query(args)
  } else if (action === 'mutate') {
    return mutation(args)
  }
  throw new Error(`Unknown query action ${action}`)
}

export default class GraphQLModel extends Backbone.Model {
  HAS_GRAPHQL_BACKEND = true

  include (mod) {
    _.extend(this, mod(this))
  }

  sync (method, model, options) {
    const queryDef = this.getQuery(options.method || method)
    const clientArgs = {
      query: queryDef.query,
      variables: queryDef.variables
    }

    return runQuery(queryDef.action, clientArgs)
      .then(response => {
        let data = response.data
        if (queryDef.parse) {
          data = queryDef.parse(data)
        }
        options.success(data)
      })
      .catch(error => {
        error.message = error.message.replace('GraphQL error: ', '').replace('[GraphQL] ', '')
        options.error(error)
        throw error
      })
  }
}
